import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';
import BASEAPI from "@/util/BASEAPI";

@Component({})
export default class OCPrizeCard extends Mixins(BASEComponentVue) {
    @Prop({
        type: Object,
        default: () => { return { "id": "0" } }
    })
    prize!: BASEAPI.Prize;

    @Emit("click")
    public click() {
    }

    public onButtonClick() {
        this.$emit("click");
    }
}
